export default ['480px', '767px', '1024px', '1200px', '1500px', '2000px']
